import styled, { css } from "styled-components";
import { limit } from "@motain/web-shared-hub/ui/elements";
import { deviceSizeQuery } from "@motain/web-shared-hub/constants";
import { WithThemeType } from "@/types/WithThemeType";

const MarginTitles = "2rem";

export const OTTPurchaseWrapper = styled.div<WithThemeType>`
  ${limit};
  min-height: 100vh;
  margin: 0 auto;
  ${() => css<WithThemeType>`
    main {
      padding-top: ${MarginTitles};

      @media all and ${deviceSizeQuery.tabletLandscape} {
        display: flex;
        flex-direction: row-reverse;
        gap: 7rem;
      }
    }

    ul {
      appearance: none;
    }

    .msd__section-header {
      text-align: left;
      margin-top: 0;
      padding-bottom: 0;
      margin-bottom: ${MarginTitles};
    }

    .msd__payment {
      margin-top: 2rem;
      padding: 0;
      border-bottom: none;

      @media all and ${deviceSizeQuery.tabletLandscape} {
        margin: 0;
        padding: 0;
      }
    }

    .msd__checkout-wrapper {
      margin: 0;
      padding: 0;
      border-bottom: none;
    }

    .msd__checkout-wrapper > div {
      margin: 0;
      padding: 0;
    }

    .msd__price-summary__ammount {
      margin: 0.5rem;
    }

    .msd__offer-card {
      border-radius: ${({ theme }) => theme.roundedCorners.big};
    }

    .msd__checkout-card-details__description span {
      font-size: ${({ theme }) => theme.typography.desktopFontSize.bodyText_7};
    }

    .msd__checkout-card-details__description p {
      // leaving this comment in case we need to revert at some point
      // this remove description text as per this task
      // https://onefootball.atlassian.net/browse/LIVEVIDEO-1584
      display: none;
      // --------------
      line-height: unset;
      font-weight: unset;
      font-size: ${({ theme }) => theme.typography.desktopFontSize.bodyText_8};
    }

    .msd__price-summary,
    .msd__payment__wrapper,
    .msd__payment__wrapper > * {
      padding: 0;
      margin: 0;
    }

    .msd__price-summary > li {
      margin: 0;
    }
    .msd__payment__wrapper,
    .msd__payment__adyen {
      max-width: unset;
    }

    .msd__header,
    .msd__header__logo,
    .msd__checkout-card-details__icon,
    .msd__checkout-card-text__description,
    .msd__subscription-card__icon {
      display: none;
    }

    .msd__footer {
      margin-top: ${MarginTitles};
      position: relative;
      padding: 1rem 0;
    }

    .msd__coupon-input__wrapper {
      display: none !important;
    }

    .msd__consents,
    .adyen-checkout__input,
    .adyen-checkout__payment-method,
    .msd__custom-dropin-title,
    .adyen-checkout__payment-method__name,
    .adyen-checkout__payment-method__name--selected,
    .adyen-checkout__fieldset__title {
      color: ${({ theme }) => theme.colors.bodyText};
      background-color: transparent;
    }

    .msd__custom-dropin--wrapper {
      max-width: unset;
      padding: 0;
      color: ${({ theme }) => theme.colors.bodyText};
      background-color: transparent;
    }
  `}
`;
